import ManualBreadcrumb from '../../components/manual/ManualBreadcrumb';
import ManualSection from '../../components/manual/ManualSection';
import ManualAlert from '../../components/manual/ManualAlert';
import ManualStep from '../../components/manual/ManualStep';

function ManualMovimentacoesPage() {
  return (
    <div className="manual-page">
      <ManualBreadcrumb items={[{ label: 'Movimentações' }]} />
      
      <div className="manual-header">
        <h1 className="manual-title">
          <i className="bi bi-arrow-left-right me-3"></i>
          Movimentações
        </h1>
        <p className="manual-subtitle">
          Registre e acompanhe entradas e saídas de adolescentes
        </p>
      </div>

      <ManualSection icon="bi-info-circle" title="O que é uma Movimentação?">
        <p>
          Uma movimentação representa um registro completo de quando um adolescente passa pelo sistema.
          Ela inclui informações sobre:
        </p>
        <ul className="manual-list">
          <li>Como o adolescente entrou (flagrante, apresentação espontânea, etc)</li>
          <li>Qual decisão foi tomada (liberdade assistida, internação, etc)</li>
          <li>Como ele saiu (liberado, internação provisória, etc)</li>
          <li>Todos os atendimentos realizados</li>
          <li>Mudanças de situação durante o processo</li>
        </ul>
      </ManualSection>

      <ManualSection icon="bi-plus-circle" title="Criando uma Nova Movimentação">
        <ManualStep number="1" title="Acesse o adolescente">
          Vá até a página de detalhes do adolescente que você quer registrar a movimentação.
        </ManualStep>

        <ManualStep number="2" title="Clique em 'Nova Movimentação'">
          No topo da página, clique no botão verde <strong>"Nova Movimentação"</strong>.
        </ManualStep>

        <ManualStep number="3" title="Preencha como entrou">
          Escolha a <strong>Situação inicial</strong> e uma das opções de <strong>Meio de Entrada</strong>:
          <ul>
            <li><strong>Apresentação Espontânea:</strong> Quando o adolescente se apresenta por conta própria</li>
            <li><strong>Flagrante:</strong> Capturado em ato infracional</li>
            <li><strong>MBA:</strong> Mandado de Busca e Apreensão</li>
            <li><strong>Flagrante + MBA:</strong> Ambas as situações</li>
            <li><strong>CDP:</strong> Vindo da Casa de Detenção Provisória</li>
            <li><strong>Recambiamento:</strong> Retorno ou deslocamento entre unidades</li>
            <li><strong>Outros:</strong> Outras formas de entrada</li>
          </ul>
        </ManualStep>

        <ManualStep number="4" title="Informe o motivo MBA quando necessário">
          Quando o meio de entrada for <strong>MBA</strong> ou <strong>Flagrante + MBA</strong>,
          selecione o motivo MBA. O sistema exige essa informação para padronizar indicadores
          e relatórios.
        </ManualStep>

        <ManualStep number="5" title="Salve">
          Clique em <strong>"Salvar Movimentação"</strong>. A movimentação será criada e passará
          a aparecer no histórico do adolescente e no dashboard, conforme filtros aplicados.
        </ManualStep>
      </ManualSection>

      <ManualSection icon="bi-window" title="Resumo e Edição da Movimentação">
        <p>
          Ao clicar no cabeçalho de uma movimentação no dashboard, o sistema abre uma janela de resumo.
          Nela é possível revisar dados, alterar informações permitidas e executar ações sensíveis.
        </p>

        <ul className="manual-list">
          <li><strong>Meio de entrada:</strong> Pode ser ajustado por usuários com permissão de edição</li>
          <li><strong>Situação:</strong> Novas situações podem ser adicionadas ao histórico</li>
          <li><strong>Motivo MBA:</strong> Pode ser alterado quando o fluxo envolver MBA</li>
          <li><strong>Cor do ato:</strong> Pode destacar visualmente o cabeçalho da movimentação</li>
          <li><strong>Decisões:</strong> São registradas no resumo ou na finalização, conforme o tipo de entrada</li>
        </ul>

        <ManualAlert type="info">
          Em <strong>Flagrante + MBA</strong>, o sistema separa <strong>Decisão Flagrante</strong>
          e <strong>Decisão MBA</strong>. Em outros meios de entrada, usa uma decisão geral.
        </ManualAlert>
      </ManualSection>

      <ManualSection icon="bi-gavel" title="Registrando Decisões e Saída">
        <p>
          Decisões judiciais e meio de saída não fazem parte da criação inicial da movimentação.
          Eles são preenchidos no resumo da movimentação ou no fluxo de finalização.
        </p>
        <ul className="manual-list">
          <li><strong>Decisão geral:</strong> Usada em movimentações que não são Flagrante + MBA</li>
          <li><strong>Decisão Flagrante:</strong> Usada no componente flagrante de uma entrada Flagrante + MBA</li>
          <li><strong>Decisão MBA:</strong> Usada no componente MBA de uma entrada Flagrante + MBA</li>
          <li><strong>Meio de saída:</strong> Obrigatório para finalizar a movimentação</li>
        </ul>
        <h4 className="mt-4">Exemplos de decisões</h4>
        <ul className="manual-list">
          <li>Liberdade Assistida (LA)</li>
          <li>Prestação de Serviços à Comunidade (PSC)</li>
          <li>Internação Provisória</li>
          <li>Semiliberdade</li>
          <li>Liberado</li>
        </ul>
      </ManualSection>

      <ManualSection icon="bi-clipboard-check" title="Registrando Atendimentos">
        <p>
          Após criar a movimentação, você pode registrar os atendimentos realizados por
          diferentes áreas. Cada atendimento tem suas particularidades:
        </p>

        <div className="manual-service-card">
          <h4><i className="bi bi-bank me-2"></i>Atendimento de Promotoria</h4>
          <p>Registra o atendimento realizado pelo Ministério Público (MPDFT):</p>
          <ul>
            <li>Marque se houve atendimento na entrada e/ou saída</li>
            <li>Informe o nome do promotor responsável</li>
            <li>Adicione observações se necessário</li>
          </ul>
        </div>

        <div className="manual-service-card">
          <h4><i className="bi bi-briefcase me-2"></i>Atendimento de Defensoria</h4>
          <p>Registra o atendimento da Defensoria Pública (DPDF):</p>
          <ul>
            <li>Marque se houve atendimento na entrada e/ou saída</li>
            <li>Informe se houve representante presente</li>
            <li>Adicione observações pertinentes</li>
          </ul>
        </div>

        <div className="manual-service-card">
          <h4><i className="bi bi-heart-pulse me-2"></i>Atendimento de Saúde</h4>
          <p>Registra procedimentos de saúde realizados:</p>
          <ul>
            <li>Marque se houve atendimento na entrada e/ou saída</li>
            <li>Indique se foi gerado processo SEI</li>
          </ul>
        </div>

        <div className="manual-service-card">
          <h4><i className="bi bi-book me-2"></i>Atendimento de Educação</h4>
          <p>Registra ações da área educacional:</p>
          <ul>
            <li>Marque se houve atendimento na entrada e/ou saída</li>
            <li>Indique se foi gerado processo SEI</li>
          </ul>
        </div>

        <div className="manual-service-card">
          <h4><i className="bi bi-clipboard-heart me-2"></i>Atendimento de Especialistas</h4>
          <p>Registra atendimentos por psicólogos, assistentes sociais, etc:</p>
          <ul>
            <li>Selecione qual especialista realizou o atendimento</li>
            <li>Marque se houve atendimento na entrada e/ou saída</li>
            <li>Indique se foi gerado processo SEI</li>
            <li>Informe se houve responsável presente e quem era</li>
          </ul>
        </div>
      </ManualSection>

      <ManualSection icon="bi-arrows-move" title="Mudando a Situação da Movimentação">
        <p>
          Durante o processo, o adolescente pode mudar de situação. As situações disponíveis são:
        </p>
        <ul className="manual-list">
          <li><strong>Disponível:</strong> Aguardando atendimento</li>
          <li><strong>Em Atendimento:</strong> Sendo atendido no momento</li>
          <li><strong>No Módulo:</strong> Alocado em um módulo específico</li>
          <li><strong>Não está na Unidade:</strong> Saiu temporariamente</li>
        </ul>

        <ManualAlert type="tip" title="Como mudar a situação">
          Na página de detalhes da movimentação, você verá botões para cada situação.
          Clique no botão correspondente para registrar a mudança. O sistema mantém
          um histórico de todas as mudanças de situação.
        </ManualAlert>
      </ManualSection>

      <ManualSection icon="bi-check-circle" title="Finalizando uma Movimentação">
        <p>
          Quando o processo terminar e o adolescente sair do sistema, você deve finalizar
          a movimentação:
        </p>

        <ManualStep number="1" title="Acesse a movimentação">
          Vá até a página de detalhes da movimentação que deseja finalizar.
        </ManualStep>

        <ManualStep number="2" title="Verifique os dados">
          Certifique-se de que:
          <ul>
            <li>Todos os atendimentos foram registrados</li>
            <li>O meio de saída foi informado</li>
            <li>As observações estão completas</li>
          </ul>
        </ManualStep>

        <ManualStep number="3" title="Finalize">
          Clique no botão <strong>"Finalizar Movimentação"</strong>. Uma movimentação finalizada
          sai automaticamente do filtro <strong>Abertos</strong> do dashboard e passa a aparecer
          em <strong>Finalizados</strong> ou <strong>Todos</strong>.
        </ManualStep>

        <ManualAlert type="warning">
          Atenção: Finalizar uma movimentação é uma ação permanente. Certifique-se de que
          todos os dados estão corretos antes de finalizar. Usuários com permissão
          <code>movimentacoes.reopen</code> podem reabrir movimentações quando houver necessidade
          administrativa.
        </ManualAlert>
      </ManualSection>

      <ManualSection icon="bi-question-circle" title="Perguntas Frequentes">
        <div className="manual-faq-item">
          <h5>Posso editar uma movimentação depois de criada?</h5>
          <p>
            Sim, usuários com permissão de edição podem ajustar dados pelo resumo da movimentação.
            Movimentações finalizadas ficam restritas e exigem reabertura para voltar ao fluxo operacional.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>É obrigatório registrar todos os atendimentos?</h5>
          <p>
            Registre apenas os atendimentos que realmente aconteceram. Se não houve atendimento
            de uma área específica, não é necessário preencher.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>O que significa "processo SEI"?</h5>
          <p>
            SEI é o Sistema Eletrônico de Informações do GDF. Marque essa opção quando
            um processo foi aberto no SEI relacionado ao atendimento.
          </p>
        </div>
      </ManualSection>
    </div>
  );
}

export default ManualMovimentacoesPage;
